module.exports = function ($, M) {
  'use strict';

  M.learning_preferences = {};

  var preferences = M.learning_preferences;

  $.extend(true, M.learning_preferences, {
    init: function () {
      $('.wrapper.pace').on(
        'click',
        '.btn-group .dropdown-menu a',
        function (e) {
          e.preventDefault();
          preferences.changeLearningPace($(this));
        },
      );

      $('.yesno').click(function () {
        preferences.changeYesNoPreferences($(this));
      });

      $('.wrapper').on('click', '.btn1', function (e) {
        e.stopPropagation();
        $(this).siblings('.dropdown-toggle').click();
      });
    },

    changeLearningPace: function (elem) {
      var btn = elem.parents('.btn-group').find('.btn1'),
        btnId = btn.attr('id'),
        num = elem.attr('data-pref'),
        plantSize = $('#garden_plant_size').data('selected'),
        waterSize = $('#garden_water_size').data('selected'),
        speedReviewSize = $('#garden_speed_review_size').data('selected');

      elem
        .parent('li')
        .addClass('active')
        .siblings()
        .removeClass('active');

      if (btnId == 'garden_plant_size') {
        plantSize = num;
      } else if (btnId == 'garden_water_size') {
        waterSize = num;
      } else if (btnId == 'garden_speed_review_size') {
        speedReviewSize = num;
      }

      // Update buttons state
      $('#garden_plant_size').text(plantSize).data('selected', plantSize);
      $('#garden_water_size').text(waterSize).data('selected', waterSize);
      $('#garden_speed_review_size')
        .text(speedReviewSize)
        .data('selected', speedReviewSize);

      // Save changes
      preferences.saveSettings({
        garden_plant_size: plantSize,
        garden_water_size: waterSize,
        garden_speed_review_size: speedReviewSize,
      });
    },

    changeYesNoPreferences: function (t) {
      var btn = t.siblings('.btn1'),
        text = btn.find('span'),
        buttonValue = t.data('content'),
        str = '',
        settingType = t.data('setting-type'),
        enableKey = false,
        profileKey,
        params = {};
      switch (settingType) {
        case 'audio':
          profileKey = 'garden_disable_audio';
          break;
        case 'tapping':
          profileKey = 'garden_disable_tapping';
          break;
        case 'labs':
          profileKey = 'enable_memrise_labs';
          enableKey = true;
          break;
        case 'typing':
          profileKey = 'garden_long_typing_memrise';
          enableKey = true;
          break;
        default:
          return;
      }

      text.animate(
        {
          'margin-left': buttonValue ? -150 : 100,
        },
        150,
        function () {
          const displayYes =
            (!buttonValue && !enableKey) || (enableKey && buttonValue);
          if (displayYes) {
            btn.removeClass('hl-danger').addClass('hl-success');
            text.css('margin-left', -150);
            str = _t('Yes');
            t.find('span')
              .removeClass('ico-arr-right')
              .addClass('ico-arr-left');
          } else {
            btn.removeClass('hl-success').addClass('hl-danger');
            str = _t('No');
            text.css('margin-left', 100);
            t.find('span')
              .removeClass('ico-arr-left')
              .addClass('ico-arr-right');
          }

          buttonValue = !buttonValue;
          $(text).text(str);
          t.data('content', buttonValue);
          text.animate(
            {
              'margin-left': 0,
            },
            150,
          );
        },
      );
      params[profileKey] = buttonValue ? 'true' : 'false';
      preferences.saveSettings(params);
    },

    saveSettings: function (params) {
      $.ajax({
        type: 'POST',
        url: '/ajax/accounts/update_settings/',
        data: params,
      });
    },
  });
};
